<template>
  <div class="home">
    <Main></Main>
  </div>
</template>

<script>
import Main from '@/components/main.vue'

export default {
  name: 'Home',
  components: {
    Main
  }
}
</script>
